import { CopyBlock, monokaiSublime as theme } from "react-code-blocks";

interface ShowCodeBlockProps {
  text: string;
  className?: string;
}

const ShowCodeBlock: React.FC<ShowCodeBlockProps> = ({ text }) => {
  return (
    <div
      className="codeBlockWrapper"
      style={{
        position: "relative",
        backgroundColor: "#2d2d2d",
        borderRadius: "8px",
        padding: "15px",
        fontFamily: "monospace",
        overflow: "auto",
        maxWidth: "620px"
      }}
    >
      <CopyBlock
        text={text}
        language="html"
        showLineNumbers={true}
        theme={theme}
        customStyle={{ overflowX: "auto" }}
      />


    </div>
  );
};

export default ShowCodeBlock;
